module.exports = __webpack_public_path__ + "img/notice-wallet.562edb22.svg";